import React, {Component} from 'react';
import qs from "query-string";
import LogoLogin from '../../atoms/LogoLogin';
import { doCheckAuth, doSSOSignIn } from '../../../actions/session';
import Button from "../../atoms/Button";
import Spinner from '../../atoms/Spinner';

class SSOSignIn extends Component {

    constructor(props) {
        super(props);
        this._onSubmit = this._onSubmit.bind(this);
        this.state = {};
        this.spinnerTimeoutId = null;
    }

    componentDidMount() {
        const queryString = (this.props.location.search || "").substring(1);
        const { err } = qs.parse(queryString);

        // Check for logout message in localStorage
        const logoutMessage = localStorage.getItem("logoutMessage");

        // Check if there's a session expiry message
        const hasExpiryMessage = logoutMessage && logoutMessage.includes("expired");

        if (err) {
            let errMsg = "";
            // We have a few different error messages that can be returned,
            // but some have information that we don't want to display to the user, so we'll slightly modify them.
            if (err === "sunf") {
                errMsg = "User not found.";
            }
            else if (err === "iau") {
                errMsg = "Inactive User.";
            }
            else if (err.includes("Invalid SAML configuration")) {
                errMsg = "Invalid SAML configuration. Not configured for SAML authentication.";
            }
            else if (err.includes("SSO Mismatched login")) {
                errMsg = "SSO mismatched login. Client user is activated with user on different branding configuration.";
            }
            else if (err.includes("Two-factor authentication required")) {
                errMsg = "Two-factor authentication (2FA) is required to access this application.";
            }
            else if (err.includes("Two-factor authentication not completed or user not enrolled")) {
                errMsg = "Two-factor authentication setup is incomplete. Please complete your 2FA enrollment with SafePass.";
            }
            else if (err.includes("Two-factor authentication failed")) {
                errMsg = "Two-factor authentication failed. Please try again.";
            }
            else errMsg = err;

            this.setState({ err: `We apologize for the inconvenience, but we encountered an error with your Single Sign-On (SSO) credentials. Please confirm your SSO details, or contact your support team for assistance. ${errMsg}` });
        } else if (!hasExpiryMessage) {
            // Only check auth and show spinner if there's no expiry message
            this.setState({ checking: true });
            doCheckAuth();

            // Always set a timeout to ensure the spinner doesn't show indefinitely
            this.spinnerTimeoutId = setTimeout(() => {
                // If we're still showing the spinner after the timeout, assume authentication failed
                // or that the user didn't respond to the session warning
                if (this.state && this.state.checking) {
                    this.setState({ checking: false });
                }
            }, 3000); // 3 second timeout
        }
        // If hasExpiryMessage is true, we don't need to do anything,
        // the component will render the login screen with the expiry message
    }

    componentWillUnmount() {
        // Clear any pending timeouts when component unmounts
        if (this.spinnerTimeoutId) {
            clearTimeout(this.spinnerTimeoutId);
            this.spinnerTimeoutId = null;
        }
    }

    _onSubmit(event) {
        if (event) {
            event.preventDefault();
        }
        localStorage.removeItem("logoutMessage");
        doSSOSignIn();
    }

    render() {
        const { err, checking } = this.state;
        if (err) {
            return (<div className="page login">
                <div className="login__wrapper">
                    <h1 className="page__title"><LogoLogin className="login__logo"/></h1>
                    <form onSubmit={this._onSubmit} className="login__form">
                        <p className="login__username">{err}</p>
                        <div className="login__btns"><Button type="submit" label="Retry Login" value="Retry Login" className="login__btn"/></div>
                        <br/>
                    </form>
                </div>
            </div>);
        } else if (checking) {
            return <div className="page logout"><Spinner/></div>
        }

        const logoutMessage = localStorage.getItem("logoutMessage");

        return (<div className="page login">
            <div className="login__wrapper">
                <h1 className="page__title"><LogoLogin className="login__logo"/></h1>
                <form onSubmit={this._onSubmit} className="login__form">
                    <p className="login__username">{logoutMessage ? logoutMessage : "You have been logged out and your session has ended."}</p>
                    <div className="login__btns"><Button type="submit" label="Login Again" value="Login Again" className="login__btn"/></div>
                    <br/>
                </form>
            </div>
        </div>);
    }
}

export default SSOSignIn;
